import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { companyInfo } from '../mockData';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold">
              Contatti
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Vieni a Trovarci o Contattaci
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Siamo a tua disposizione per ogni informazione o richiesta
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            {/* Address */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="bg-green-100 p-4 rounded-xl">
                  <MapPin className="text-green-600" size={28} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-slate-900 mb-2">Sede</h3>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {companyInfo.address}
                  </p>
                  <p className="text-sm text-gray-500 mt-2">Zona Trionfale, Roma</p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="bg-green-100 p-4 rounded-xl">
                  <Phone className="text-green-600" size={28} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-slate-900 mb-3">Telefono</h3>
                  <div className="space-y-3">
                    <div>
                      <div className="text-sm text-gray-500 mb-1">Cellulare</div>
                      <a 
                        href={`tel:${companyInfo.phone}`}
                        className="block text-xl font-semibold text-green-600 hover:text-green-700 transition-colors"
                      >
                        {companyInfo.phone}
                      </a>
                    </div>
                    <div>
                      <div className="text-sm text-gray-500 mb-1">Fisso</div>
                      <a 
                        href={`tel:${companyInfo.office}`}
                        className="block text-xl font-semibold text-green-600 hover:text-green-700 transition-colors"
                      >
                        {companyInfo.office}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="bg-green-100 p-4 rounded-xl">
                  <Mail className="text-green-600" size={28} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-slate-900 mb-2">Email</h3>
                  <a 
                    href={`mailto:${companyInfo.email}`}
                    className="text-lg text-gray-700 hover:text-green-600 transition-colors break-all"
                  >
                    {companyInfo.email}
                  </a>
                </div>
              </div>
            </div>

            {/* Hours */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className="bg-green-100 p-4 rounded-xl">
                  <Clock className="text-green-600" size={28} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-slate-900 mb-3">Orari</h3>
                  <div className="space-y-2 text-gray-700">
                    <div className="flex justify-between">
                      <span>Lunedì - Venerdì:</span>
                      <span className="font-semibold">8:30 - 18:00</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Sabato:</span>
                      <span className="font-semibold">9:00 - 13:00</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Domenica:</span>
                      <span className="font-semibold text-red-600">Chiuso</span>
                    </div>
                  </div>
                  <p className="text-sm text-green-600 font-semibold mt-3">
                    * Assistenza emergenze 24/7
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="relative">
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg h-full min-h-[600px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2968.2!2d12.4656!3d41.9462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f61b6532013db%3A0x8b0!2sVia%20Giuseppe%20Boffito%2C%2024%2C%2000135%20Roma%20RM!5e0!3m2!1sit!2sit!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mappa ItalSerrande"
              ></iframe>
            </div>

            {/* Company Info Card Overlay */}
            <div className="absolute bottom-6 left-6 right-6 bg-white rounded-xl p-6 shadow-2xl border border-gray-200">
              <div className="flex items-center gap-3 mb-3">
                <img 
                  src={companyInfo.logo} 
                  alt={companyInfo.name}
                  className="h-10 w-auto"
                />
              </div>
              <p className="text-sm text-gray-600">
                <strong>P.IVA:</strong> {companyInfo.piva}
              </p>
              <p className="text-sm text-gray-600">
                <strong>C.F:</strong> {companyInfo.cf}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
